import Axios from "axios";
import store from "../store/store";
import auth from "./auth";

/*
 * Modo "solo informe de turnos de operarios" (restriccion 84, permisiva: la fila en
 * `restrictions` lo activa, y basta con tenerla en uno de los negocios del usuario).
 *
 * Un usuario con ella solo puede estar en el informe de turnos y en su perfil: cualquier
 * otra ruta (sidebar, navbar, breadcrumb o escrita a mano en la URL) le devuelve al
 * informe. La API aplica lo mismo por su lado (middleware en numier-api Src/Routes.php),
 * asi que esto es la parte de interfaz, no la unica barrera.
 *
 * Si se cambia el id, cambiarlo tambien en la API ($idRestriccionSoloTurnos).
 */
export const ID_RESTRICCION_SOLO_TURNOS = 84;

export const RUTA_SOLO_TURNOS = "/informes/operarios/turnos-operarios";

const RUTAS_PERMITIDAS = [RUTA_SOLO_TURNOS, "/perfil"];

// Rutas sin sesion: no se tocan.
const RUTAS_LIBRES = ["/login", "/rememberPass", "/terms", "/serverdown"];

// Se pregunta una vez por JWT: al cerrar sesion y entrar con otro usuario se vuelve a
// preguntar. Si la consulta falla no se guarda, y se reintenta en la siguiente navegacion.
let jwtConsultado = null;
let consultaEnCurso = null;

function normalizar(path) {
  const limpio = (path || "/").replace(/\/+$/, "");
  return limpio === "" ? "/" : limpio;
}

export function cargarSoloTurnos() {
  const jwt = store.getters.jwt;

  if (!jwt) {
    jwtConsultado = null;
    consultaEnCurso = null;
    store.commit("changeSoloTurnos", false);
    return Promise.resolve(false);
  }

  if (jwtConsultado === jwt && consultaEnCurso) {
    return consultaEnCurso;
  }

  // En la primera navegacion App.vue aun no ha guardado la URL de la API en el store.
  const apiUrl =
    store.getters.apiUrl ||
    store.state.xapiUrl ||
    process.env.VUE_APP_API_URL ||
    "http://localhost:8082/";

  jwtConsultado = jwt;
  consultaEnCurso = Axios.get(apiUrl + "general/getPermission", {
    params: { jwt: jwt, idRestriccion: ID_RESTRICCION_SOLO_TURNOS },
    headers: { Authorization: "Bearer " + jwt },
  })
    .then(function (response) {
      const activo = !!(response.data && response.data.result && response.data.result.permitido);
      store.commit("changeSoloTurnos", activo);
      return activo;
    })
    .catch(function (error) {
      // Si no se puede comprobar se deja la interfaz normal (la API sigue cerrando) y se
      // olvida la consulta para reintentar en la siguiente navegacion.
      console.error("No se pudo comprobar el modo solo turnos:", error);
      jwtConsultado = null;
      consultaEnCurso = null;
      store.commit("changeSoloTurnos", false);
      return false;
    });

  return consultaEnCurso;
}

// Guard global (router.beforeEach): cubre tambien las rutas que no llevan Guard.auth.
export function guardSoloTurnos(to, from, next) {
  if (to.name === "turnos-operarios-external-link" || RUTAS_LIBRES.includes(normalizar(to.path))) {
    next();
    return;
  }

  if (!auth.check()) {
    next();
    return;
  }

  cargarSoloTurnos().then(function (soloTurnos) {
    if (!soloTurnos || RUTAS_PERMITIDAS.includes(normalizar(to.path))) {
      next();
    } else {
      next({ path: RUTA_SOLO_TURNOS, replace: true });
    }
  });
}



// WEBPACK FOOTER //
// ./src/routes/solo-turnos.js